<template>
    <div id="mtsCustomerPopup" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open" class="container h-100">
            <form v-if="page === 'customerId'" @submit.prevent="customerIdSubmit" class="row h-100">
                <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('mts_customer_popup.title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <div class="d-flex justify-content-center my-4">
                        <img src="/images/theme/mts/bear/male-default.png" class="vh-10" />
                    </div>

                    <h5 class="text-orange mb-0" v-html="$t('mts_customer_popup.customerid_subtitle')"></h5>
                    <div><hr style="width: 3em;"/></div>

                    <div class="form-group mb-5 pl-3 pr-3 pl-md-5 pr-md-5">
                        <label for="customerId" class="mb-3">{{ $t('mts_customer_popup.customerid_input') }}</label>
                        <b-form-input v-model="customerId" id="customerId" type="number" class="blue-b text-center" size="lg"></b-form-input>
                        <div class="alert alert-dark small mt-3" v-html="$t('mts_customer_popup.info')"></div>
                    </div>

                    <div class="form-group mt-auto mb-5">
                        <b-button @click="btnSfx();" type="submit" variant="primary" size="lg" class="pl-5 pr-5" >
                            {{ $t('mts_customer_popup.next_btn') }}
                        </b-button>
                    </div>
                </div>
            </form>
            <div v-if="page === 'selectEmail'" class="row h-100">
                <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('mts_customer_popup.title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <h5 class="text-orange mb-0" v-html="$t('mts_customer_popup.list_subtitle')"></h5>
                    <div><hr style="width: 3em;"/></div>
                    <ul v-if="emails.length > 0" class="email-list">
                        <li @click="sendCode(email)" v-for="email in emails" :key="email">
                            <h5 class="mb-0 ml-3">{{ email }}</h5>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="page === 'confirm'" class="row h-100">
                <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('mts_customer_popup.title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <div class="d-flex justify-content-center my-4">
                        <img src="/images/icon-message.png" class="vh-10 p-2" />
                    </div>

                    <h5 class="text-orange mb-0" v-html="$t('mts_customer_popup.code_subtitle')"></h5>
                    <div><hr style="width: 3em;"/></div>

                    <div class="form-group mb-5 pl-3 pr-3 pl-md-5 pr-md-5">
                        <label for="code" class="mb-3">{{ $t('mts_customer_popup.code_input') }}</label>
                        <b-form-input v-model="code" id="code" type="numbner" class="blue-b text-center" size="lg"></b-form-input>
                    </div>

                    <div class="form-group mt-auto mb-5">
                        <b-button @click="btnSfx();" type="submit" variant="primary" size="lg" class="pl-5 pr-5" >
                            {{ $t('mts_customer_popup.confirm_btn') }}
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

import api from '../../api'


const MtsCustomerPopup = Vue.component('mts-customer-popup', {
    data() {
        return {
            page: 'customerId',
            open: false,
            customerId: "",
            emails: [],
            code: "",
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
        show() {
            this.open = true;
            this.page = 'customerId';
            this.customerId = "";
            this.code = "";
            this.emails = [];
        },
        hide() {
            this.open = false;
        }, 

        customerIdSubmit(){
            if(this.customerId.trim() === "") return;
            const $this = this;
            
            api.mtsCustomerEmails(this.customerId.trim())
                .then(res => {
                    $this.emails = res.data;
                    $this.page = 'selectEmail';
                })
                .catch(err => {
                    api.baseErrorHendler(err);
                })
        },

        sendCode(email){
            const $this = this;

            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.mtsCustomerCode(this.customerId.trim(), email)
                .then(res => {
                    $this.page = 'confirm';
                })
                .catch(err => {
                    api.baseErrorHendler(err);
                })
                .then(() => {
                    loader.classList.remove("show");
                });
        },

        verifyCode(){
            if(this.code.trim() === "") return;
            const $this = this;

            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.mtsCustomerConfirm(this.customerId.trim(), this.code.trim())
                .then(res => {
                    // reload my data
                    $this.$store.dispatch('auth/getMe');
                    $this.hide();
                })
                .catch(err => {
                    api.baseErrorHendler(err);
                })
                .then(() => {
                    loader.classList.remove("show");
                });
        },
    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        }
    }
})

export default MtsCustomerPopup
</script>